import { Action } from 'redux';
import { FetchBetaNodesResponseAction, actionTypes as t } from '../actions';

export const isFetchingBetaNodesReducer = (isFetchingBetaNodes = false, action: Action) => {
  switch (action.type) {
    case t.FETCH_BETA_NODES_RESPONSE:
    case t.FETCH_BETA_NODES_ERROR:
      return false;
    case t.FETCH_BETA_NODES_REQUEST:
      return true;
    default:
      return isFetchingBetaNodes;
  }
};

export const betaNodesReducer = (betaNodes = { supported: [] }, action: Action) => {
  switch (action.type) {
    case t.FETCH_BETA_NODES_RESPONSE:
      return (action as FetchBetaNodesResponseAction).payload.response;
    default:
      return betaNodes;
  }
};
